import type { TOC } from '@ember/component/template-only';
import { array } from '@ember/helper';
import { pageTitle } from 'ember-page-title';

interface BootstrapSignature {
  Args: {
    model: unknown;
    controller: unknown;
  };
}

<template>
  {{pageTitle "Bootstrap"}}
  {{outlet}}

  <div class="container my-5">
    <h1 class="display-1">Bootstrap 5</h1>
    <p class="lead">This page can be used to test the custom Bootstrap theme.</p>

    <div class="row my-5">
      <div class="col">
        <h1 class="h3 text-primary">Headings</h1>

        <h1>Heading 1</h1>
        <h2>Heading 2</h2>
        <h3>Heading 3</h3>
        <h4>Heading 4</h4>
        <h5>Heading 5</h5>
        <h6>Heading 6</h6>
      </div>
      <div class="col">
        <h1 class="h3 text-primary">Display</h1>

        <h1 class="display-1">Display 1</h1>
        <h1 class="display-2">Display 2</h1>
        <h1 class="display-3">Display 3</h1>
        <h1 class="display-4">Display 4</h1>
        <h1 class="display-5">Display 5</h1>
        <h1 class="display-6">Display 6</h1>
      </div>
    </div>

    <div class="row my-5">
      <div class="col">
        <h1 class="h3 text-primary">Font sizes</h1>

        <p class="fs-1">.fs-1 text</p>
        <p class="fs-2">.fs-2 text</p>
        <p class="fs-3">.fs-3 text</p>
        <p class="fs-4">.fs-4 text</p>
        <p class="fs-5">.fs-5 text</p>
        <p class="fs-6">.fs-6 text</p>
      </div>
      <div class="col">
        <h1 class="h3 text-primary">Font weights</h1>

        <p class="fw-bold">Bold text.</p>
        <p class="fw-bolder">Bolder weight text (relative to the parent
          element).</p>
        <p class="fw-semibold">Semibold weight text.</p>
        <p class="fw-medium">Medium weight text.</p>
        <p class="fw-normal">Normal weight text.</p>
        <p class="fw-light">Light weight text.</p>
        <p class="fw-lighter">Lighter weight text (relative to the parent
          element).</p>
        <p class="fst-italic">Italic text.</p>
        <p class="fst-normal">Text with normal font style</p>
      </div>
    </div>

    <div class="my-5">
      <h1 class="h3 text-primary">Typography</h1>

      <p class="lead">Lorem ipsum odor amet, consectetuer adipiscing elit. Per
        aenean nunc urna at; purus elementum fringilla netus. Faucibus nam
        laoreet dapibus velit volutpat ullamcorper placerat felis fermentum.
        Iaculis eu mattis duis semper, metus etiam. Odio primis efficitur
        pellentesque porta magnis odio vitae? Quisque laoreet augue senectus
        nibh aliquam; adipiscing sit magna. Nullam eros senectus ac class;
        facilisis ad nunc suspendisse. Lacinia ex suscipit eleifend massa fusce.
        Tortor aliquam dapibus vestibulum vulputate varius.</p>
      <p>Gravida a urna velit ligula congue. Penatibus dolor ad eros
        sollicitudin et nostra ac. Congue eleifend consequat amet nisl conubia
        donec dui. Lacus habitasse amet duis cras dolor maximus faucibus
        consectetur. Ultricies vulputate dictum nibh sociosqu libero fames
        vivamus. Orci class efficitur purus ante sollicitudin massa. Primis
        consectetur et luctus tempus ridiculus, aenean felis. Cubilia curabitur
        velit, congue et conubia pellentesque dui cubilia.</p>

      <blockquote class="blockquote">
        <p>A well-known quote, contained in a blockquote element.</p>
      </blockquote>

      <figure>
        <blockquote class="blockquote">
          <p>A well-known quote, contained in a blockquote element.</p>
        </blockquote>
        <div class="blockquote-footer">
          Someone famous in
          <div title="Source Title">Source Title</div>
        </div>
      </figure>

      <p class="lh-1">This is a long paragraph written to show how the
        line-height of an element is affected by our utilities. Classes are
        applied to the element itself or sometimes the parent element. These
        classes can be customized as needed with our utility API.</p>
      <p class="lh-sm">This is a long paragraph written to show how the
        line-height of an element is affected by our utilities. Classes are
        applied to the element itself or sometimes the parent element. These
        classes can be customized as needed with our utility API.</p>
      <p class="lh-base">This is a long paragraph written to show how the
        line-height of an element is affected by our utilities. Classes are
        applied to the element itself or sometimes the parent element. These
        classes can be customized as needed with our utility API.</p>
      <p class="lh-lg">This is a long paragraph written to show how the
        line-height of an element is affected by our utilities. Classes are
        applied to the element itself or sometimes the parent element. These
        classes can be customized as needed with our utility API.</p>
    </div>

    <div class="my-5">
      <h1 class="h3 text-primary">Buttons</h1>
      <p>Buttons are customised to have curved edges and additional padding.</p>

      <div class="row row-cols-2 gy-3">
        <div class="col">
          <h2 class="gud-eyebrow">Primary button</h2>
          {{#each (array "lg" "md" "sm") as |size|}}
            <p>
              <button type="button" class="btn-primary btn-{{size}}">
                Primary
              </button>
              <button
                type="button"
                class="btn-primary btn-{{size}}"
                disabled={{true}}
              >
                Primary
              </button>
              <a class="btn btn-primary btn-{{size}}" href="#">Link</a>
            </p>
          {{/each}}
        </div>
        <div class="col">
          <h2 class="gud-eyebrow">Primary outline button</h2>
          {{#each (array "lg" "md" "sm") as |size|}}
            <p>
              <button type="button" class="btn-outline-primary btn-{{size}}">
                Primary
              </button>
              <button
                type="button"
                class="btn-outline-primary btn-{{size}}"
                disabled={{true}}
              >
                Primary
              </button>
              <a class="btn btn-outline-primary btn-{{size}}" href="#">Link</a>
            </p>
          {{/each}}
        </div>
        <div class="col">
          <h2 class="gud-eyebrow">Dark button</h2>
          {{#each (array "lg" "md" "sm") as |size|}}
            <p>
              <button type="button" class="btn-dark btn-{{size}}">
                Primary
              </button>
              <button
                type="button"
                class="btn-dark btn-{{size}}"
                disabled={{true}}
              >
                Primary
              </button>
              <a class="btn btn-dark btn-{{size}}" href="#">Link</a>
            </p>
          {{/each}}
        </div>
        <div class="col">
          <h2 class="gud-eyebrow">Dark outline button</h2>
          {{#each (array "lg" "md" "sm") as |size|}}
            <p>
              <button type="button" class="btn-outline-dark btn-{{size}}">
                Outline
              </button>
              <button
                type="button"
                class="btn-outline-dark btn-{{size}}"
                disabled={{true}}
              >
                Outline
              </button>
              <a class="btn btn-outline-dark btn-{{size}}" href="#">Link</a>
            </p>
          {{/each}}
        </div>
      </div>
    </div>

    <div class="my-5">
      <h1 class="h3 text-primary">Eyebrows</h1>
      <p>The
        <code>eyebrow</code>
        class can be applied to any heading. The headings should look consistent
        regardless of level.</p>

      <h1 class="gud-eyebrow">Eyebrow H1</h1>
      <h2 class="gud-eyebrow">Eyebrow H2</h2>
      <h3 class="gud-eyebrow">Eyebrow H3</h3>
      <h4 class="gud-eyebrow">Eyebrow H4</h4>
      <h5 class="gud-eyebrow">Eyebrow H5</h5>
      <h6 class="gud-eyebrow">Eyebrow H6</h6>
    </div>

    <div class="my-5">
      <h1 class="h3 text-primary">Colours</h1>

      <h2 class="gud-eyebrow">Corporate colours</h2>
      <p>Corporate colours will remain unchanged by the client branding.</p>

      <div class="row mb-5">
        <div class="col">
          <div class="bg-hultashridge-heritage text-white p-3">Heritage with
            contrasting color</div>
          <div class="bg-hultashridge-cascade text-white p-3">Cascade with
            contrasting color</div>
          <div class="bg-hultashridge-teal text-white p-3">Teal with contrasting
            color</div>
          <div class="bg-hultashridge-copper p-3">Copper with contrasting color</div>
          <div class="bg-hultashridge-tacao p-3">Tacao with contrasting color</div>
          <div class="bg-hultashridge-albescent p-3">Albescent with contrasting
            color</div>
          <div class="bg-hultashridge-sisal p-3">Sisal with contrasting color</div>
          <div class="bg-hultashridge-charcoal text-white p-3">Charcoal with
            contrasting color</div>
          <div class="bg-hultashridge-black text-white p-3">Black with
            contrasting color</div>
          <div class="bg-hultashridge-white p-3">White with contrasting color</div>

        </div>
        <div class="col">
          <div class="text-hultashridge-heritage p-3">Heritage with contrasting
            color</div>
          <div class="text-hultashridge-cascade p-3">Cascade with contrasting
            color</div>
          <div class="text-hultashridge-teal p-3">Teal with contrasting color</div>
          <div class="text-hultashridge-copper p-3">Copper with contrasting
            color</div>
          <div class="text-hultashridge-tacao p-3">Tacao with contrasting color</div>
          <div class="text-hultashridge-albescent bg-dark p-3">Albescent with
            contrasting color</div>
          <div class="text-hultashridge-sisal bg-dark p-3">Sisal with
            contrasting color</div>
          <div class="text-hultashridge-charcoal p-3">Charcoal with contrasting
            color</div>
          <div class="text-hultashridge-black p-3">Black with contrasting color</div>
          <div class="text-hultashridge-white bg-dark p-3">White with
            contrasting color</div>
        </div>
      </div>

      <h2 class="gud-eyebrow">Client colours</h2>
      <p>Bootstrap's primary, secondary, light and dark colours could be
        overridden by the client branding.</p>

      <div class="row mb-3">
        <div class="col">
          <div class="text-bg-primary p-3">Primary with contrasting color</div>
          <div class="text-bg-secondary p-3">Secondary with contrasting color</div>
          <div class="text-bg-light p-3">Light with contrasting color</div>
          <div class="text-bg-dark p-3">Dark with contrasting color</div>
        </div>
        <div class="col">
          <div class="text-primary p-3">Primary with contrasting color</div>
          <div class="text-secondary p-3">Secondary with contrasting color</div>
          <div class="text-light bg-dark p-3">Light with contrasting color</div>
          <div class="text-dark p-3">Dark with contrasting color</div>
        </div>
      </div>

      <p class="mb-5">
        <button type="button" class="btn btn-primary">Primary</button>
        <button type="button" class="btn btn-secondary">Secondary</button>
        <button type="button" class="btn btn-light">Light</button>
        <button type="button" class="btn btn-dark">Dark</button>
        <button type="button" class="btn btn-outline-primary">Primary</button>
        <button
          type="button"
          class="btn btn-outline-secondary"
        >Secondary</button>
        <button type="button" class="btn btn-outline-light">Light</button>
        <button type="button" class="btn btn-outline-dark">Dark</button>
      </p>

      <h2 class="gud-eyebrow">Bootstrap semantic colours</h2>
      <p>Other Bootstrap semantic colours have been customised but are unlikely
        to be changed by the client branding.</p>

      <div class="row mb-3">
        <div class="col">
          <div class="text-bg-success p-3">Success with contrasting color</div>
          <div class="text-bg-danger p-3">Danger with contrasting color</div>
          <div class="text-bg-warning p-3">Warning with contrasting color</div>
          <div class="text-bg-info p-3">Info with contrasting color</div>
        </div>
        <div class="col">
          <div class="text-success p-3">Success with contrasting color</div>
          <div class="text-danger p-3">Danger with contrasting color</div>
          <div class="text-warning p-3">Warning with contrasting color</div>
          <div class="text-info p-3">Info with contrasting color</div>
        </div>
      </div>

      <p class="mb-5">
        <button type="button" class="btn btn-success">Success</button>
        <button type="button" class="btn btn-danger">Danger</button>
        <button type="button" class="btn btn-warning">Warning</button>
        <button type="button" class="btn btn-info">Info</button>
        <button type="button" class="btn btn-outline-success">Success</button>
        <button type="button" class="btn btn-outline-danger">Danger</button>
        <button type="button" class="btn btn-outline-warning">Warning</button>
        <button type="button" class="btn btn-outline-info">Info</button>
      </p>
    </div>
  </div>
</template> satisfies TOC<BootstrapSignature>;
